import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Container,
  H1,
  H3,
  Label,
  Main,
  Section,
  Span,
} from "../Styles/Global.Styled";
import { css } from "styled-components";
import ProfileIcon from "../Icons/ProfileIcon";
import { getUserProfile } from "../api/user";
import EditIcon from "../Icons/EditIcon";
import EditUserForm from "../Forms/EditUserForm/EditUserForm";
import {
  addressFormData,
  companyNameProps,
  companyRegCodeProps,
  dailingCodeProps,
  firstNameProps,
  lastNameProps,
  passwordProps,
  phoneNumberProps,
} from "../helpers/formProps";
import { AuthContext } from "../Context/AuthContext";
import Login from "./Login";

const mainStyle = css`
  display:flex;
  align-items: center;
  justify-content:center;
  padding: 5vh 5vw;
  /* border:2px solid red; */
`;

const sectionStyle = css`
  /* border: 2px solid red; */
  max-width: 50vh;
  width:100%;
  padding: 2vh 0;
  gap: 3vh;
`;

const h1Style = css`
  display: flex;
  align-items: center;
  gap: 1vh;
`;

const h3Style = css`
  font-size: 1.7vh;
  margin-bottom: -1.5vh;
`;

const labelsStyle = css`
  width: 12vh;
  font-size: 1.4vh;
  font-weight: 650;
  font-family: "Segoe UI";
`;

const spanStyle = css`
  flex-grow: 1;
`;

const buttonStyle = css`
  width: 3.5vh;
  height: 3.5vh;
  border-radius: 50%;
  flex-direction: column;
  font-size: 1vh;
`;

// Reusable row component
const DetailRow = ({ label, value, onEdit }) => (
  <Container>
    <Label $baseStyle={labelsStyle}>{label}</Label>
    <Span $baseStyle={spanStyle}>{value}</Span>
    {onEdit && (
      <Button $baseStyle={buttonStyle} onClick={onEdit}>
        <EditIcon />
      </Button>
    )}
  </Container>
);

const Account = ({ setPopUp, showParentToast }) => {
  const [userDetails, setUser] = useState(null);
  const { isLoggedIn } = useContext(AuthContext);

  const handleEdit = (formPropsFn, attrName) => {
    setPopUp({
      isOpen: true,
      content: (
        <EditUserForm
          attrName={attrName}
          formProps={formPropsFn}
          setPopUp={setPopUp}
          showParentToast={showParentToast}
        />
      ),
    });
  };

  const addressText = userDetails?.address
    ? `${userDetails.address.address_line}, ${userDetails.address.postcode}
${userDetails.address.city}, ${userDetails.address.country}`
    : "Not available";

  useEffect(() => {
    const callApi = async () => {
      try {
        const res = await getUserProfile();
        setUser(res.profile);
      } catch (error) {
        console.error("Error fetching user profile:", error);
      }
    };

    callApi();
  }, [isLoggedIn]);

  if (!isLoggedIn) {
    return (
      <Main $baseStyle={mainStyle}>
        <Login />
      </Main>
    );
  } else {
    return (
      <Main $baseStyle={mainStyle}>
        <H1 $baseStyle={h1Style}>
          <ProfileIcon style={{ height: "4vh", width: "4vh" }} /> Account
          Details
        </H1>
        {/* Manager details */}
        <Section $baseStyle={sectionStyle}>
          <H3 $baseStyle={h3Style}>Manager details</H3>
          <DetailRow
            label="Name"
            value={
              userDetails?.account_manager.firstname +
                " " +
                userDetails?.account_manager.lastname || "Not available"
            }
            onEdit={() =>
              handleEdit([
                firstNameProps(userDetails?.account_manager.firstname),
                lastNameProps(userDetails?.account_manager.lastname),
              ])
            }
          />
          <DetailRow
            label="Phone number"
            value={userDetails?.account_manager.phone_number}
            onEdit={() =>
              handleEdit(
                [
                  dailingCodeProps(
                    userDetails?.account_manager.phone_number.substring(0, 3)
                  ),
                  phoneNumberProps(
                    userDetails?.account_manager.phone_number.substring(3)
                  ),
                ],
                "Phone number"
              )
            }
          />
        </Section>
        {/* Login credentials */}
        <Section $baseStyle={sectionStyle}>
          <H3 $baseStyle={h3Style}>Login credentials</H3>
          <DetailRow
            label="Email"
            value={userDetails?.account_manager.email || "Not available"}
          />
          <DetailRow
            label="Password"
            value={"****"}
            onEdit={() =>
              handleEdit([
                passwordProps("Current password"),
                { ...passwordProps("New password"), helperTxt: true },
              ])
            }
          />
        </Section>
        {/* Company Details */}
        <Section $baseStyle={sectionStyle}>
          <H3 $baseStyle={h3Style}>Company Details</H3>
          <DetailRow
            label="Company name"
            value={userDetails?.company_name || "Not available"}
            onEdit={() =>
              handleEdit([companyNameProps(userDetails?.company_name)])
            }
          />
          <DetailRow
            label="Reg. number"
            value={userDetails?.registration_number || "Not available"}
            onEdit={() =>
              handleEdit([
                companyRegCodeProps(userDetails?.registration_number),
              ])
            }
          />
          <DetailRow
            label="Address"
            value={addressText}
            onEdit={() =>
              handleEdit(addressFormData({ address: userDetails.address }))
            }
          />
        </Section>
      </Main>
    );
  }
};

export default Account;
